import React from "react";
import { Link, NavLink } from "react-router-dom";
import Div from "../Div";

import SocialWidget from "../Widget/SocialWidget";

import "./footer.scss";

export default function Footer() {
  // const copyrightLinks = [
  //   {
  //     title: "Privacy Policy",
  //     href: "/privacy",
  //   },
  // ];

  return (
    <footer className="footer">
      <Div className="container">
        <Div className="bottom_footer">
          <Div className="copyright">
            © 2020-{new Date().getFullYear()} <Link to="/"> The Social Eye ® |</Link> All rights reserved.
          </Div>

          <SocialWidget />
          <Div className="bottom_footer_right">
            {/* <Privacy/> */}
            <NavLink
                        to="/privacy"
                        // onClick={() => setMobileToggle(false)}
                        
                      >
                        Privacy Policy
                      </NavLink>
            {/* <MenuWidget menuItems={copyrightLinks} variant=" _style2" /> */}
          </Div>
        </Div>
      </Div>
    </footer>
  );
}
